import { FormattedEmailTemplate } from "@idw-types/data/email-template";

export enum EmailTemplatesActionTypes {
    // Email Templates
    SET_EMAIL_TEMPLATES_LOADING = "SET_EMAIL_TEMPLATES_LOADING",
    SET_EMAIL_TEMPLATES = "SET_EMAIL_TEMPLATES",
    ADD_EMAIL_TEMPLATE = "ADD_EMAIL_TEMPLATE"
}

// Email Templates
type SetEmailTemplatesLoadingAction = {
    type: EmailTemplatesActionTypes.SET_EMAIL_TEMPLATES_LOADING,
    payload: { isLoading: boolean; }
};

export const setEmailTemplatesLoading = (isLoading: boolean): SetEmailTemplatesLoadingAction => ({
    type: EmailTemplatesActionTypes.SET_EMAIL_TEMPLATES_LOADING,
    payload: { isLoading }
});

type SetEmailTemplatesAction = {
    type: EmailTemplatesActionTypes.SET_EMAIL_TEMPLATES,
    payload: { emailTemplates: Array<FormattedEmailTemplate>; }
}

export const setEmailTemplates = (emailTemplates: Array<FormattedEmailTemplate>): SetEmailTemplatesAction => ({
    type: EmailTemplatesActionTypes.SET_EMAIL_TEMPLATES,
    payload: { emailTemplates }
});

type AddEmailTemplateAction = {
    type: EmailTemplatesActionTypes.ADD_EMAIL_TEMPLATE;
    payload: { emailTemplate: FormattedEmailTemplate };
};

export const addEmailTemplate = (emailTemplate: FormattedEmailTemplate): AddEmailTemplateAction => ({
    type: EmailTemplatesActionTypes.ADD_EMAIL_TEMPLATE,
    payload: { emailTemplate }
});

export type EmailTemplatesActions =
    // Email Templates
    SetEmailTemplatesLoadingAction |
    SetEmailTemplatesAction |
    AddEmailTemplateAction